import $ from 'domtastic'
import Cookies from 'js-cookie'




/* COOKIES NOTICE
---------------------------------------------------------------------------------------------------- */

export default class CookiesNotice {

    constructor() {
        this.activeEvent = APP.Browser.supports.passive ? { passive: false } : false


        this.$els = {
            ctn   : $('.cookies-notice'),
            block : $('.cookies-notice__block'),
            btn   : $('.cookies-notice .btn'),
        }


        this.touchStartHandler = (e) => { this.onTouchStart(e) }
        this.touchMoveHandler  = (e) => { this.onTouchMove(e) }
        this.wheelHandler      = (e) => { this.onWheel(e) }

        this.startTouchMovePrevention()
        this.bindEvents()
    }


    bindEvents() {
        this.$els.btn.on('click', (e) => { this.onButtonClick(e) })
    }




    /* Handlers
    --------------------------------------------------------- */

    onButtonClick(e) {
        e.preventDefault()

        Cookies.set('cookies', 'accepted', { expires: 365 })
        $(document).trigger('cookiesAccepted')

        this.endTouchMovePrevention()
        this.$els.ctn.addClass('is-closed')
        setTimeout(() => { this.$els.ctn.remove() }, 1000)
    }


    onTouchStart(e) {
        if (e.targetTouches.length === 1) {
            this.startTouchY = e.targetTouches[0].clientY
        }
    }


    onTouchMove(e) {
        e.stopPropagation()

        const o   = this.$els.block[0]
        const oH  = o.clientHeight
        const oSH = o.scrollHeight
        const oST = o.scrollTop

        const moveY = e.targetTouches[0].clientY - this.startTouchY
        const isOverlayScrolled = oSH - oST <= oH


        if ((oST === 0 && moveY > 0) || (isOverlayScrolled && moveY < 0)) {
            e.preventDefault()
        }
    }


    onWheel(e) {
        e.stopPropagation()

        const o   = this.$els.block[0]
        const oH  = o.clientHeight
        const oSH = o.scrollHeight
        const oST = o.scrollTop

        const isOverlayScrolled = oSH - oST <= oH

        if ((oST === 0 && e.deltaY < 0) || (isOverlayScrolled && e.deltaY > 0)) {
            e.preventDefault()
        }
    }




    /* Actions
    --------------------------------------------------------- */

    startTouchMovePrevention() {
        this.$els.block[0].addEventListener('touchstart', this.touchStartHandler)
        this.$els.block[0].addEventListener('touchmove', this.touchMoveHandler, this.activeEvent)
        this.$els.block[0].addEventListener('wheel', this.wheelHandler, this.activeEvent)
    }


    endTouchMovePrevention() {
        this.$els.block[0].removeEventListener('touchstart', this.touchStartHandler)
        this.$els.block[0].removeEventListener('touchmove', this.touchMoveHandler)
        this.$els.block[0].removeEventListener('wheel', this.wheelHandler)
    }

}



